import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import AdminThemeToggle from "@/components/AdminThemeToggle";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  // Preserve the page the user was on before being logged out by the 401
  // interceptor, so they can resume their workflow after re-authenticating.
  const returnTo = params.get("returnTo");
  const safeReturnTo = returnTo && returnTo.startsWith("/admin") ? returnTo : "/admin";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Välkommen tillbaka");
      navigate(safeReturnTo);
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Inloggning misslyckades");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 relative">
      <div className="absolute top-5 right-5"><AdminThemeToggle /></div>
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <Link to="/" data-testid="admin-login-logo" className="inline-block group">
            <span className="text-[#C5A059] font-semibold text-base tracking-[0.3em] uppercase font-['Outfit'] group-hover:opacity-80 transition-opacity">SERAVA</span>
          </Link>
          <p className="text-white/40 text-xs tracking-[0.2em] uppercase font-['Outfit'] mt-1">Admin-panel</p>
        </div>
        <form onSubmit={handleSubmit} data-testid="admin-login-form" className="space-y-4">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="E-post" required data-testid="admin-email-input"
            className="w-full bg-[#141414] border border-[#262626] px-5 py-3.5 text-white font-['Outfit'] text-sm placeholder:text-white/25 focus:outline-none focus:border-[#C5A059]/50 transition-colors" />
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Lösenord" required data-testid="admin-password-input"
            className="w-full bg-[#141414] border border-[#262626] px-5 py-3.5 text-white font-['Outfit'] text-sm placeholder:text-white/25 focus:outline-none focus:border-[#C5A059]/50 transition-colors" />
          <button type="submit" disabled={loading} data-testid="admin-login-btn"
            className="btn-primary w-full py-3.5 text-xs tracking-[0.15em] uppercase font-['Outfit'] disabled:opacity-50">
            {loading ? "Loggar in..." : "Logga in"}
          </button>
        </form>
      </div>
    </div>
  );
}
